import clsx from 'clsx';
import styles from './CrosswordQuestion.module.scss';
import {
    getTypeOfResult,
    handleVibrate,
    processString,
} from '~/utils/common';
import { forwardRef, useEffect, useRef, useState } from 'react';
import { TextButton, ResultBox, WordBox } from '~/components';
import { useTranslation } from 'react-i18next';

const calcBoardBoundary = (boards) => {
    // console.log('boards', boards)
    // tính số dòng, số cột max
    let maxRow = 0;
    let maxColumn = 0;
    boards.forEach(board => {
        if (board.direction === 'row') {
            if (maxColumn < board.position.column - 1 + board.answer.length)
                maxColumn = board.position.column - 1 + board.answer.length
            if (maxRow < board.position.row)
                maxRow = board.position.row
        }
        if (board.direction === 'column') {
            if (maxColumn < board.position.column)
                maxColumn = board.position.column
            if (maxRow < board.position.row - 1 + board.answer.length)
                maxRow = board.position.row - 1 + board.answer.length
        }
    });
    return {
        row: maxRow, column: maxColumn
    }
}

const createEmptyBoardFromCorrectBoard = (board) => {
    return board.map(row => row.map(cell => {
        return {
            ...cell,
            // status: 'right'
            text: ''
        }
    }))
}

const createCorrectBoard = (boardData) => {
    // tính số cột và số dòng
    const { row: maxRow, column: maxColumn } = calcBoardBoundary(boardData);
    // tạo mặc định board rỗng
    const board = []
    for (let r = 0; r < maxRow; r++) {
        const row = [];
        for (let c = 0; c < maxColumn; c++) {
            let cell = {
                hide: true,
                next: []
            }
            row.push(cell);
        }
        board.push(row);
    }
    // thêm dữ liệu vào board
    boardData.forEach(ele => {
        for (let i = 0; i < ele.answer.length; i++) {
            // console.log('ele.answer', ele.answer)
            if (ele.direction === 'row') {
                board[ele.position.row - 1][ele.position.column - 1 + i] = {
                    ...board[ele.position.row - 1][ele.position.column - 1 + i],
                    hide: false,
                    text: ele.answer[i],
                }
                if (i < ele.answer.length - 1) { // còn phía sau
                    board[ele.position.row - 1][ele.position.column - 1 + i] = {
                        ...board[ele.position.row - 1][ele.position.column - 1 + i],
                        next: [
                            ...board[ele.position.row - 1][ele.position.column - 1 + i].next,
                            { row: ele.position.row - 1, column: ele.position.column - 1 + i + 1 }
                        ]
                    }
                }
            }
            if (ele.direction === 'column') {
                board[ele.position.row - 1 + i][ele.position.column - 1] = {
                    ...board[ele.position.row - 1 + i][ele.position.column - 1],
                    hide: false,
                    text: ele.answer[i]
                }
                if (i < ele.answer.length - 1) { // còn phía sau
                    board[ele.position.row - 1 + i][ele.position.column - 1] = {
                        ...board[ele.position.row - 1 + i][ele.position.column - 1],
                        next: [
                            ...board[ele.position.row - 1 + i][ele.position.column - 1].next,
                            { row: ele.position.row - 1 + i + 1, column: ele.position.column - 1 }
                        ]
                    }
                }
            }
            if (i === 0) {
                if (board[ele.position.row - 1][ele.position.column - 1].start) {
                    board[ele.position.row - 1][ele.position.column - 1] = {
                        ...board[ele.position.row - 1][ele.position.column - 1],
                        start: [
                            ...board[ele.position.row - 1][ele.position.column - 1].start,
                            {
                                no: ele.no,
                                direction: ele.direction
                            }
                        ]

                    }
                }
                else {
                    board[ele.position.row - 1][ele.position.column - 1] = {
                        ...board[ele.position.row - 1][ele.position.column - 1],
                        start: [
                            {
                                no: ele.no,
                                direction: ele.direction
                            }
                        ]
                    }
                }
            }
        }
    });
    return board;
}

function CrosswordQuestion(
    {
        question,
        audioMap,
        notiCompleteAnAnswer,
        notiContinue,
        updateResult,
        className,
        ...rest
    },
    ref,
) {
    const { t } = useTranslation();
    const [board, setBoard] = useState([[]]);
    const [correctBoard, setCorrectBoard] = useState([[]]);
    const [kq, setKq] = useState(null);
    const [result, setResult] = useState('wrong'); // no_check || right || wrong
    const [isShowResult, setIsShowResult] = useState(false);
    const [movingFocus, setMovingFocus] = useState(false);
    const [inputing, setInputing] = useState({ row: -1, column: -1 })
    const [preInputing, setPreInputing] = useState(null);
    const refBoard = useRef();
    function handleOnClickContinue() {
        updateResult(kq, true);
    }

    function findResult() {
        let rs = true;
        const newBoard = board.map((row, rowIndex) => {
            return row.map((cell, columnIndex) => {
                let temp = true;
                if (cell.hide === false) {
                    console.log('check', cell.text, correctBoard[rowIndex][columnIndex].text)
                    if (processString(cell.text) !== processString(correctBoard[rowIndex][columnIndex].text)) {
                        temp = false
                        rs = false;
                    }
                }
                return {
                    ...cell,
                    status: temp ? 'right' : 'wrong'
                }
            })
        });
        setBoard(newBoard);
        console.log('rs', rs)
        return { count: 1, correct: rs ? 1 : 0 };
    }

    function handleOnClickCheck() {
        const kq = findResult();
        const type = getTypeOfResult(kq);
        notiCompleteAnAnswer(type);
        setResult(type);
        handleVibrate('strong');
        removeFocus(); // để ẩn bàn phím ảo
        setIsShowResult(true);
        setKq(kq);
    }

    const removeFocus = () => {
        // Lấy phần tử hiện đang focus
        const focusedElement = document.activeElement;
        // Kiểm tra nếu phần tử đang focus là input hoặc textarea
        if (
            focusedElement.tagName === 'INPUT' ||
            focusedElement.tagName === 'TEXTAREA'
        ) {
            // Gọi phương thức blur() để làm mất focus
            focusedElement.blur();
        }
    };

    function handleOnClickAnswer(e) {
        console.log('handleOnClickAnswer')
        if (refBoard && refBoard.current)
            refBoard.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        setBoard(preBoard => preBoard.map((row, rowIndex) => {
            return row.map((cell, columnIndex) => {
                return {
                    ...cell,
                    text: correctBoard[rowIndex][columnIndex].text
                }
            })
        }));
        handleVibrate('slight');
    }

    // Mỗi khi question thay đổi
    useEffect(() => {
        const b = createCorrectBoard(question.board);
        setCorrectBoard(b);
        setBoard(createEmptyBoardFromCorrectBoard(b));
    }, [question]);


    const updateInputing = (position) => {
        setInputing(pre => {
            setPreInputing(pre);
            return position;
        });
    }

    const handleMoveFocus = (position) => {

        if (board[position.row][position.column].next.length > 0) {
            setMovingFocus(true);
            if (board[position.row][position.column].next.length === 1 || preInputing.row === -1)
                updateInputing(board[position.row][position.column].next[0]);
            else {
                if (preInputing.row === inputing.row) { // đang nhảy theo chiều ngang
                    if (board[position.row][position.column].next[0].row === inputing.row)
                        updateInputing(board[position.row][position.column].next[0]);
                    else
                        updateInputing(board[position.row][position.column].next[1]);
                } else if (preInputing.column === inputing.column) { // đang nhảy theo chiều dọc
                    if (board[position.row][position.column].next[0].column === inputing.column)
                        updateInputing(board[position.row][position.column].next[0]);
                    else
                        updateInputing(board[position.row][position.column].next[1]);
                }
            }
        }
    }

    const handleOnBlurWordBox = (position, text) => {
        if (board[position.row][position.column].text !== text) {
            setBoard(preBoard => preBoard.map((row, rowIndex) => {
                return row.map((cell, columnIndex) => {
                    if (position.row === rowIndex && position.column === columnIndex)
                        return {
                            ...cell,
                            text: text
                        }
                    else return cell
                })
            }));
        }
        if (!movingFocus)
            updateInputing({ row: -1, column: -1 })
        setMovingFocus(false);
    }

    return (
        <div {...rest} className={clsx(styles.question, className)}>
            <div className={clsx(styles.images)}>
                {question.images.map((image, index) => (
                    <img key={image} src={image} alt={image} />
                ))}
            </div>
            <div className={clsx(styles.content)}>
                {question.content}
            </div>
            <div ref={refBoard} className={clsx(styles.board)}>
                {board.map((row, rowIndex) => (
                    <div className={styles.row}
                        key={"row" + rowIndex}
                    >
                        {row.map((cell, colIndex) => (
                            <WordBox key={"cell" + rowIndex + "_" + colIndex} box={cell}
                                position={{ row: rowIndex, column: colIndex }}
                                inputing={inputing} updateInputing={updateInputing}
                                handleMoveFocus={handleMoveFocus}
                                handleOnBlurWordBox={handleOnBlurWordBox}>
                            </WordBox>
                        ))}
                    </div>
                ))}
            </div>
            <div className={clsx(styles.askWrapper)}>
                {question.board.map((ele, idx) => {
                    return <div key={idx} className={clsx(styles.ask)}>
                        <div className={clsx(styles.text)}>
                            {ele.ask.text}
                        </div>
                        <div className={clsx(styles.askImage)}>
                            <img src={ele.ask.image} alt={ele.ask.text} />
                        </div>
                    </div>
                }
                )}</div>


            {/* action */}
            {
                !isShowResult && (
                    <div className={styles.action}>
                        <TextButton
                            normal
                            onClick={handleOnClickCheck}
                        >
                            {t('check')}
                        </TextButton>
                    </div>
                )
            }
            {/* result */}
            {
                isShowResult && (
                    <ResultBox
                        hideAnswer={false}
                        question={question}
                        result={result}
                        handleOnClickContinue={handleOnClickContinue}
                        handleOnClickAnswer={handleOnClickAnswer}
                    />
                )
            }
        </div >
    );
}
export default forwardRef(CrosswordQuestion);